/*
vuex最核心的管理对象store
 */
import Vue from 'vue'
import Vuex from 'vuex'
import type_tube_vuex from './modules/type_tube_vuex';
import resources_tube_vuex from './modules/resources_tube_vuex';
import expediting_vuex from './modules/expediting_vuex';
import channel_common_vuex from './modules/channel_common_vuex';
import common_vuex from './modules/common_vuex';
import new_display_objec_vuex from './modules/new_display_objec_vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        type_tube_vuex,
        resources_tube_vuex,
        expediting_vuex,
        channel_common_vuex,
        common_vuex,
        new_display_objec_vuex
    }
}) 